<div class="privacy-page">
  <nav class="privacy-nav">
    <a routerLink="/" class="nav-back">← Home</a>
    <span class="nav-brand">Rogledi</span>
  </nav>

  <main class="privacy-content">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Aggiornata il 29 agosto 2026</p>

    <section>
      <h2>1. Titolare del trattamento</h2>
      <p>Il sito <strong>rogledi.it</strong> è gestito da Andrea Rogledi. Per qualsiasi richiesta relativa alla privacy puoi contattarci tramite il <a routerLink="/" fragment="contatti">modulo di contatto</a>.</p>
    </section>

    <section>
      <h2>2. Dati raccolti</h2>
      <p>Questo sito raccoglie esclusivamente i dati che tu fornisci volontariamente tramite il modulo di contatto (nome, eventuale numero di telefono, messaggio). Questi dati vengono utilizzati unicamente per risponderti e non vengono ceduti a terzi.</p>
      <p>Non utilizziamo sistemi di profilazione e non ricostruiamo il percorso dei singoli visitatori. Rileviamo soltanto statistiche aggregate e anonime sulle visite, descritte al punto 4.</p>
    </section>

    <section>
      <h2>3. Cookie tecnici</h2>
      <p>Il sito utilizza un unico cookie tecnico (<code>cookie_consent</code>) memorizzato nel <em>localStorage</em> del tuo browser per ricordare se hai accettato l'informativa cookie. Non contiene dati personali e non viene trasmesso a server esterni.</p>
    </section>

    <section>
      <h2>4. Statistiche di visita</h2>
      <p>Per sapere quante persone visitano il sito utilizziamo <strong>Cloudflare Web Analytics</strong>, un servizio di misurazione che <strong>non installa cookie</strong>, non memorizza identificatori sul tuo dispositivo e non ti segue su altri siti. Vengono raccolti solo dati aggregati e anonimi: numero di pagine viste, indirizzo della pagina, sito di provenienza, tipo di browser, sistema operativo e Paese.</p>
      <p>Per erogare il servizio, il tuo indirizzo IP transita dai server di Cloudflare Inc., che lo utilizza esclusivamente per distinguere le visite e non lo conserva in forma leggibile. Il trattamento si fonda sul legittimo interesse del titolare a conoscere l'andamento del proprio sito. Puoi impedire la raccolta usando un qualsiasi blocco degli script di tracciamento: il sito continua a funzionare identico.</p>
    </section>

    <section>
      <h2>5. Cookie di profilazione e pubblicità</h2>
      <p>Il sito <strong>non mostra annunci pubblicitari</strong> e non utilizza cookie di profilazione di terze parti.</p>
    </section>

    <section>
      <h2>6. Diritti dell'utente</h2>
      <p>Ai sensi del Regolamento UE 2016/679 (GDPR) hai diritto di accedere, rettificare o cancellare i dati che ci hai fornito. Per esercitare questi diritti contattaci tramite il <a routerLink="/" fragment="contatti">modulo di contatto</a>.</p>
    </section>

    <section>
      <h2>7. Modifiche alla presente policy</h2>
      <p>Eventuali aggiornamenti a questa pagina saranno pubblicati su questo indirizzo con la data di aggiornamento indicata in cima.</p>
    </section>
  </main>

  <footer class="privacy-footer">
    <span>© 2026 Rogledi</span>
    <a routerLink="/" fragment="contatti">Contatti</a>
  </footer>
</div>
